import { type FC } from 'react';
import cx from 'classnames';

// @ts-expect-error - no TypeScript definitions yet
import { IconCheck } from 'src/assets/icons/IconCheck';
import { ButtonLikeProgressBar } from 'src/components/ButtonLikeProgressBar';
// @ts-expect-error - CustomButton doesn't have TypeScript definitions
import { CUSTOM_BUTTON_COLOR, CUSTOM_BUTTON_SIZE, CustomButton } from 'src/components/CustomButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import {
  COMPLIANCE_STATUS,
  type ComplianceStatus,
  isInProgressComplianceStatus,
} from 'src/data/compliance';

import { useStyles } from './useStyles';

interface Props {
  className?: string;
  status: ComplianceStatus;
  progress?: number;
  onApplyCompliance: Function;
  disabled?: boolean;
}

export const ComplianceControl: FC<Props> = ({
  className,
  status,
  progress,
  onApplyCompliance,
  disabled,
}) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      {isInProgressComplianceStatus(status) ? (
        <CustomTooltip title="Creating AP-compliant version">
          <ButtonLikeProgressBar
            className={styles.progress}
            progress={progress}
            text="Apply AP style guide"
            size={CUSTOM_BUTTON_SIZE.small}
          />
        </CustomTooltip>
      ) : status === COMPLIANCE_STATUS.done ? (
        <CustomButton
          className={styles.button}
          onClick={onApplyCompliance}
          color={CUSTOM_BUTTON_COLOR.silver}
          size={CUSTOM_BUTTON_SIZE.small}
          disabled={disabled}
        >
          Apply AP style guide
        </CustomButton>
      ) : status === COMPLIANCE_STATUS.applied ? (
        <>
          <IconCheck className={styles.icon} />
          <CustomTypography
            className={styles.label}
            variant={TYPOGRAPHY_VARIANT.medium14}
          >
            AP style guide applied
          </CustomTypography>
        </>
      ) : status === COMPLIANCE_STATUS.doneWithErrors ? (
        <CustomTypography
          className={styles.label}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          Done with errors
        </CustomTypography>
      ) : (
        <CustomTypography
          className={styles.label}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          No compliance data
        </CustomTypography>
      )}
    </div>
  );
};
